import styled from 'styled-components';

export const StyledAutoCompleteInfo = styled.div`
  padding: 2rem;
`;

export const StyledAutoCompleteMain = styled.main`
  height: auto;
  max-height: 20rem;
  overflow-y: scroll;
  border: 1px solid #eee;
  font-size: 1.1rem;
`;

export const StyledAutoCompleteListOption = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledAutoCompleteList = styled.div``;
